import {Component, OnDestroy, OnInit} from '@angular/core';
import {ReplaySubject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {ActivatedRoute} from "@angular/router";
import {ContractService} from "../../../../shared/services/contract.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialog} from "@angular/material/dialog";
import {AuthService} from "../../../../shared/services/auth.service";
import {Contract} from "../../../../shared/interface/contract";
import {HttpErrorResponse} from "@angular/common/http";
import {ContractBalanceService} from "../../../../shared/services/contract-balance.service";
import {ContractBalance} from "../../../../shared/interface/contract-balance";
import {UserPermissions} from "../../../../shared/interface/user-permissions";

@Component({
  selector: 'app-contract-balance-details',
  templateUrl: './contract-balance-details.component.html',
  styleUrls: ['./contract-balance-details.component.scss']
})
export class ContractBalanceDetailsComponent implements OnInit, OnDestroy {

  contractBalanceObject?: ContractBalance;
  modify = false;
  contractBalance: ReplaySubject<ContractBalance> = new ReplaySubject<ContractBalance>(1);
  userPermissions: ReplaySubject<UserPermissions>;

  contractBalanceId: string;
  selectedTab: number;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private route: ActivatedRoute,
    private contractBalanceService: ContractBalanceService,
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private auth: AuthService,
  ) {
    this.userPermissions = auth.getUserPermissions();

  }

  ngOnInit(): void {
    this.route.params
      .pipe(takeUntil(this.destroyed$))
      .subscribe(params => {
        this.contractBalanceId = params.id;
        this.selectedTab = 0;
        this.loadContractBalance();
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  loadContractBalance(): void {
    this.contractBalanceService.get(this.contractBalanceId).subscribe((contractBalance: ContractBalance) => {
      this.contractBalance.next(contractBalance);
      this.contractBalanceObject = contractBalance;
    }, (error: HttpErrorResponse) => {
      this.snack.open('Nie udało się pobrać danych salda', error.status.toString(), {
        duration: 2000
      });
    });
  }


}
